<template>
    <div class="page home-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <exam v-if="examData" :exam="examData.exam" :questions="examData.questions" :categories_select_items="examData.categories_select_items" :sessions_count="examData.sessions_count" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Exam from './Exam'

export default {
    name: "",
    components: {
        Exam
    },
    data(){
        return {
            loading: false,
            examData: null,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get(`/exams/${this.id}`).then(response=>{
                    this.examData = response.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
